/* eslint-disable max-len */
import React from "react"
import Pagination from "../../../../components/Pagination"
import { useNavigate } from "react-router-dom";
import { formatAdjustedDate } from "../../../../CommonMethods/formatDate"

const TrialBalanceTable = ({
    trialBalance,
    searchParams, 
    setSearchParams,
    setPageType,  
    setPageLoading, 
    trialBalanceCount
}) => {

    const navigate = useNavigate()

    /* The `hasDifference` constant in the code snippet is checking if the `trialBalance` object has values
    for `punched_in_ob_difference` and `other_difference`, and if those values are not null or
    undefined. It then further checks if the parsed float values of `punched_in_ob_difference` and
    `other_difference` are not equal to 0.00 after rounding to 2 decimal places. */
    const hasDifference = trialBalance?.punched_in_ob_difference !== null &&
        trialBalance?.punched_in_ob_difference !== undefined &&
        trialBalance?.other_difference !== null &&
        trialBalance?.other_difference !== undefined &&
        (parseFloat(parseFloat(trialBalance?.punched_in_ob_difference).toFixed(2)) !== 0.00 ||
            parseFloat(parseFloat(trialBalance?.other_difference).toFixed(2)) !== 0.00);

    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams) 
        setSearchParams({ ...params, main_page_number: pageNum.selected + 1 })
    }

    const ledgerHandler = (
        ledgerName,
        transactionCredit,
        transactionDebit,
        transactionType,
        openingBalanceAmount,
        ledgerMainParent,
        ledgerID
    ) => {
        if(ledgerName === 'P & L Account'){
            navigate('/financial-statements/profit-and-loss-sheet')
        } else {
            let params = Object?.fromEntries(searchParams);
            if (ledgerName === 'Opening Stock'){
                if(parseFloat(openingBalanceAmount).toFixed(2) === '0.00'){
                    return
                } else{
                    params.type = 'opening-stock'
                    setPageType('opening-stock');
                }
            } else if(transactionCredit === '0' && transactionDebit === '0' && ledgerName !== 'Opening Stock'){
                setPageType('transaction');
                params.type = 'transaction'
            }else if (transactionType !== 'others'){
                setPageType('drill_down');
                params.type = 'drill_down'
            } else {
                setPageType('transaction');
                params.type = 'transaction'
            }
            // Update type parameter in params based on item properties
            setSearchParams({...params});

            let dataName
            if(transactionCredit === '0' && transactionDebit === '0' && ledgerName !== 'Opening Stock'){
                dataName = ledgerName+' Ledger Extract'
            } else if(ledgerName === 'Opening Stock' || transactionType !== 'others'){
                dataName = ledgerName
            } else {
                dataName = ledgerName+' Ledger Extract'
            }
            params.main_group = ledgerMainParent
            params.ledger_id = ledgerID

            // Update searchParams and navigate to the appropriate URL
            navigate(`/financial-statements/trial-balance-sheet/Trial%20BS/${
                encodeURIComponent(dataName)}${
                Object.keys(params).length === 0 ? '' : `?${new URLSearchParams(params).toString()}`}`);  
        }

    }

    //add the below line to 3rd div's class to get inside scrolling for table
    //${!hasDifference ? trialBalanceCount > 50 ? 'max-h-[calc(100vh-268px)]' : 'max-h-[calc(100vh-208px)]' : trialBalanceCount > 50 ? 'max-h-[calc(100vh-308px)]' : 'max-h-[calc(100vh-248px)]'}

    return(
        <div class=" w-full relative">
            <div class=" overflow-x-auto pb-[6px] scroll-bar -mx-[2px]">
                <div class={`flex px-[6px]`}>
                    <table aria-label="Outside Table" class="w-full relative stickyhead auto-layout" id="admin-table">
                        <thead>
                            <tr>
                                <th colSpan={2} class="min-w-[320px] 2xl:min-w-[500px] border-r-[2px] border-[#C2DCEF]">
                                    <span class="sticky top-0 flex items-center justify-start">Ledger Particulars</span>
                                </th>
                                <th colSpan={2} class="min-w-[160px]">
                                    <span class="sticky top-0 flex items-center justify-center">Opening Balance</span>
                                </th>
                                <th colSpan={2} class="min-w-[160px]">
                                    <span class="sticky top-0 flex items-center justify-center">Transactions</span>
                                </th>
                                <th colSpan={2} class="min-w-[160px]">
                                    <span class="sticky top-0 flex items-center justify-center">Closing Balance</span>
                                </th>
                            </tr>
                            <tr aria-colspan="7" class="h-1"></tr>
                        </thead>
                        <tbody >
                            
                            <tr class="group">
                                <td class="text-start  border-r border-[#EDEDED] font-semibold min-w-[130px] 2xl:min-w-[180px]">Classification</td>
                                <td class="text-start  font-semibold border-r border-[#EDEDED] min-w-[190px] max-w-[190px] 2xl:min-w-[320px]">Name</td>

                                <td class="text-end  font-semibold min-w-[80px]">Debit</td>
                                <td class="text-end  font-semibold border-r border-[#EDEDED] min-w-[80px]">Credit</td>

                                <td class="text-end  font-semibold min-w-[80px]">Debit</td>
                                <td class="text-end  font-semibold border-r border-[#EDEDED] min-w-[80px]">Credit</td>

                                <td class="text-end  font-semibold min-w-[80px]">Debit</td>
                                <td class="text-end  font-semibold min-w-[80px]">Credit</td>
                            </tr>
                            {trialBalance?.data?.map((trial, index) => (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]" key={trial?.ledger_id+'trial'}></tr>
                                    <tr id={trial?.ledger_name+'0'} key={trial?.ledger_id}
                                        class={`group cursor-pointer`}
                                        onClick={()=> {ledgerHandler(
                                            trial?.ledger_name,
                                            trial?.transaction_cr,
                                            trial?.transaction_dr,
                                            trial?.transaction_type,
                                            trial?.opening_balance_amount,
                                            trial?.ledger_main_parent,
                                            trial?.ledger_id
                                        )}}
                                    >
                                        <td class="text-start  border-r border-[#EDEDED]" id={'classification_'+trial?.ledger_name}>{trial?.group_type+'-'+trial?.ledger_main_parent || '-'}</td>
                                        <td class="text-start  border-r border-[#EDEDED]" id={trial?.ledger_name}>{trial?.ledger_name || '-'}</td>

                                        <td class="text-end" id={'opening_balance_amount_dr_'+index}>{trial?.group_type === "PL" && trial?.ledger_name !== 'Opening Stock' ? '-' : trial?.opening_balance_amount_type === 'dr' ? Math.abs(parseFloat(trial?.opening_balance_amount)).toFixed(2) : '0.00' || '-'}</td>
                                        <td class="text-end  border-r border-[#EDEDED] capitalize" id={'opening_balance_amount_cr_'+index}>{trial?.group_type === "PL" && trial?.ledger_name !== 'Opening Stock' ? '-' : trial?.opening_balance_amount_type === 'cr' ? Math.abs(parseFloat(trial?.opening_balance_amount)).toFixed(2) : '0.00' || '-'}</td>

                                        <td class="text-end" id={'transaction_dr'+index}>{Math.abs(parseFloat(trial?.transaction_dr)).toFixed(2) || '-'}</td>
                                        <td class="text-end  border-r border-[#EDEDED] capitalize" id={'transaction_cr'+index}>{Math.abs(parseFloat(trial?.transaction_cr)).toFixed(2) || '-'}</td>
                                        
                                        <td class="text-end"  id={'closing_balance_amount_dr_'+index}>{trial?.closing_balance_amount_type === 'dr' ? Math.abs(parseFloat(trial?.closing_balance_amount)).toFixed(2) : '0.00' || '-'}</td>
                                        <td class="text-end"  id={'closing_balance_amount_cr_'+index}>{trial?.closing_balance_amount_type === 'cr' ? Math.abs(parseFloat(trial?.closing_balance_amount)).toFixed(2) : '0.00' || '-'}</td>
                                    </tr>
                                </>))}

                            <tr class="group">
                                <td class="text-start  font-semibold border-r border-[#EDEDED]" id={'Total'}>Total</td>
                                <td class="text-end  border-r border-[#EDEDED] font-semibold" ></td>

                                <td class="text-end  font-semibold" id={'opening_balance_total_debit'}>{Math.abs(parseFloat(trialBalance?.total_amounts?.total_opening_balance_amount_dr)).toFixed(2) || '0.00'}</td>
                                <td class="text-end  font-semibold border-r border-[#EDEDED]" id={'opening_balance_total_credit'}>{Math.abs(parseFloat(trialBalance?.total_amounts?.total_opening_balance_amount_cr)).toFixed(2) || '0.00'}</td>

                                <td class="text-end  font-semibold" id={'transactions_total_debit'}>{Math.abs(parseFloat(trialBalance?.total_amounts?.total_transaction_dr)).toFixed(2) || '0.00'}</td>
                                <td class="text-end  font-semibold border-r border-[#EDEDED]" id={'transactions_total_credit'}>{Math.abs(parseFloat(trialBalance?.total_amounts?.total_transaction_cr)).toFixed(2) || '0.00'}</td>

                                <td class="text-end  font-semibold" id={'closing_balance_total_debit'}>{Math.abs(parseFloat(trialBalance?.total_amounts?.total_closing_balance_amount_dr)).toFixed(2) || '0.00'}</td>
                                <td class="text-end  font-semibold" id={'closing_balance_total_credit'}>{Math.abs(parseFloat(trialBalance?.total_amounts?.total_closing_balance_amount_cr)).toFixed(2) || '0.00'}</td>
                            </tr>
                        </tbody>
                        
                    </table>
                </div>
            </div>
            {trialBalanceCount > 50 && <div className="pt-[20px]">
                <Pagination
                    TotalCount={trialBalanceCount}
                    limit={50}
                    totalPageNumber={Math?.ceil(trialBalanceCount / 50)}
                    selectedPageNumber={Number(searchParams.get('main_page_number')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />
            </div>}
            {hasDifference && (
                <div className={`mb-10 mt-3`}>
                    <p>Difference in punched opening balance: <span id='trial_balance_punched_in_ob_difference'>{parseFloat(trialBalance?.punched_in_ob_difference).toFixed(2)}</span></p>
                    <p>Other difference: <span id='trial_balance_other_difference'>{parseFloat(trialBalance?.other_difference).toFixed(2)}</span></p>
                </div>
            )}
        </div>
    )
}


export default TrialBalanceTable;